import courseService from "../services/courseService";
import { useParams } from "react-router-dom";
import { useEffect,useState } from "react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { IndentIncrease, UserRound} from "lucide-react"
import { Badge } from "../components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger }  from "@radix-ui/react-tabs"
import { toast } from "sonner";
import paymentService from "../services/paymentService";
import useAuthStore from "../store/authStore";
import { checkRegisterCourse } from "../utils/checkRegister";
import { useNavigate, useLocation } from "react-router-dom";
import useCourseStore from "../store/courseStore";
import enrollmentService from "../services/enrollmentService";
import { BookMarked, BookOpenCheck, CircleCheckBig } from "lucide-react"
import { stateStore } from "../store/stateStore";
import { Loader } from "../components/ui/loader";

import testService from "../services/testService";
export default function CourseDetailPage () {
  const { id } = useParams();
  const navigate = useNavigate()
  const pathName = useLocation().pathname
  const [course, setCourse] = useState()
  const [enrollmentCount, setEnrollmentCount] = useState(0)
  // const [lessons, setLessons] = useState([])
  const { user} = useAuthStore()
  const { fetchLessonByCourseId, lessons} = useCourseStore()
  const handlePay = async () => {
    try {
      const response = await paymentService.payWithVNPay({amount: parseInt(course.price), courseId: course.id})
      window.location.href = response.data.paymentUrl
    } catch (error) {

    }
  }
  const [tests, setTests] = useState([])
  const { isLoading} = stateStore()
  const fetchTests = async () => {
    try {
      const response = await testService.getTestByCourseId(id)
      setTests(response.data)

    } catch (error) {

      console.error(error)
    }
  }

  const fetchCourse = async () => {
    try {
      const response = await courseService.getCourseById(id)
      if (user && checkRegisterCourse(user.enrollments, id)) response.data.registered = true
      else response.data.registered =false
      setCourse(response.data)
    } catch (error) {
      toast.error(error)
    }
  }

  const fetchEnrollmentCount = async () => {
    try {
      const response = await enrollmentService.getEnrollmentByCourseId(id)
      setEnrollmentCount(response.data.total_enrollments)
    } catch (error) {
      toast.error(error)
    }
  }

  // const fetchLessons = async () => {
  //   try {
  //     const response = await lessonService.getLessonByCourseId(id)
  //     setLessons(response.data)
  //   } catch (error) {
  //     toast.error(error)
  //   }
  // }

  useEffect(() => {
    fetchCourse()
    fetchLessonByCourseId(id)
    fetchEnrollmentCount()
    fetchTests()
  },[user,id])
  if (!course || isLoading) return <Loader />
  return (
    <div className="py-8 space-y-8">
    <Card className="p-8 space-y-4">
      <div className="grid md:grid-cols-[2fr_1fr] gap-2">
        <div className="space-y-2">
          <h1 className="font-bold text-xl">{course.title}</h1>
          <p>{course.description}</p>
          <div className="flex flex-row gap-2">
            <Badge className="bg-gray-400 text-white">Listening</Badge>
            <Badge className="bg-gray-400 text-white">Reading</Badge>
            <Badge className="bg-gray-400 text-white">TOEIC</Badge>
          </div>
          {!course.registered && <p className="text-primary font-bold text-xl">{parseInt(course.price).toLocaleString("vi-VN")} VND</p>}

          <div>
            {
              user ?
              <Button variant={course.registered ? "secondary" : "default"} className="bg-green-400 rounded-md max-md:w-full" onClick={course.registered ? () => navigate(`${pathName}/lesson/${lessons[0].id}`) : handlePay}>
              {course.registered ? "Học ngay" : "Đăng ký học"}
             </Button>
             :
             <Button className="bg-primary rounded-md" onClick={() =>  navigate("/login")}>
              Vui lòng đăng nhập
            </Button>
            }

          </div>
        </div>

        <div className="w-full h-full bg-center rounded-lg min-h-48" style={{backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT_URL}/files/${course.image_id}')`}}>
        </div>

      </div>
      <div className="flex flex-row gap-8">
        <div className="flex flex-row gap-2 text-xs md:text-md">
          <IndentIncrease />
          <span>{lessons.length} bài giảng</span>
        </div>
        <div className="flex flex-row gap-2 text-xs md:text-md">
          <UserRound />
          <span>{enrollmentCount} người đăng ký</span>
        </div>
      </div>
    </Card>
    <Tabs defaultValue="intro" className="w-full">
      <TabsList className="shadow-sm py-2 px-8 space-x-8 rounded-lg mb-4">
        <TabsTrigger value="intro" className="data-[state=active]:font-bold data-[state=active]:border-blue-900 data-[state=active]:border-b-2">Giới thiệu</TabsTrigger>
        <TabsTrigger value="course" className="data-[state=active]:font-bold data-[state=active]:border-blue-900 data-[state=active]:border-b-2">Danh sách bài giảng</TabsTrigger>
        <TabsTrigger value="test" className="data-[state=active]:font-bold data-[state=active]:border-blue-900 data-[state=active]:border-b-2">Bài kiểm tra cuối khóa</TabsTrigger>
      </TabsList>
      <TabsContent value="intro" className="p-8 shadow-md">{course.description_detail}</TabsContent>
      <TabsContent value="course" className="p-8 shadow-md">

        <ul className="space-y-4">
          {lessons.map((lesson, index) => (
            <div className="flex flex-row py-2 gap-2 border-b border-dashed">
            <BookMarked />
            <li className="cursor-pointer hover:font-semibold hover:text-primary w-max" key={lesson.id} onClick={() => {
              if (course.registered) navigate(`${pathName}/lesson/${lesson.id}`)
              else toast.warning("Vui lòng đăng ký khóa học!")
            }}>
              <div>
              Bài {index + 1}: {lesson.title}
              </div>
              <p className="text-xs text-gray-400">{lesson.total_exercises} bài tập</p>
            </li>
            </div>
          ))}


        </ul>
      </TabsContent>
      <TabsContent value="test" className="p-8 shadow-md">
        <ul>
          {tests.map((test, index) => (
          <div className="flex flex-row py-2 gap-2 items-center justify-between border-b border-dashed">
              <div className="flex flex-row py-2 gap-2">
              <BookOpenCheck />
              <li className="cursor-pointer w-max hover:font-semibold hover:text-primary" key={test.id} onClick={() => navigate(`/courses/${id}/test/${test.id}`)}>
              Bài kiểm tra #{index+1}
              <p className="text-xs text-gray-400">{test.total_questions} câu hỏi</p>
              </li>
            </div>


            {test.is_done &&
              <div className="flex flex-row gap-2">
              {test.highest_score}
              <CircleCheckBig className="text-green-700"/>
            </div>
            }


          </div>

          ))}
        </ul>

      </TabsContent>
  </Tabs>

    </div>
  )
}
